<template>
  <v-container>
    <apexchart
      type="bar"
      width="100%"
      height="322"
      :options="chart.options"
      :series="chart.series"
    ></apexchart>
  </v-container>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'BarChart',
  components: {
    apexchart: VueApexCharts,
  },
  props: [
    'chartData',
    'languageTypes',
  ],
  data() {
    return {
      chart: {
        type: 'bar',
        options: {
          plotOptions: {
            bar: {
              horizontal: false,
              distributed: true,
              borderRadius: 12,
              borderRadiusApplication: 'end',
              borderRadiusWhenStacked: 'last',
              columnWidth: '50%',
              barHeight: '100%',
              colors: {
                ranges: [{
                  from: 0,
                  to: 0,
                  color: undefined
                }],
                backgroundBarColors: ["#EDEDED"],
                backgroundBarOpacity: 1,
                backgroundBarRadius: 12,
              },
              grid: {
                show: true,
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            show: false
          },
          colors: ["#C388FF", "#889FFF", "#C9EFA8", "#DFDC8A", "#DDB0A8", "#D3D3D3"],
          xaxis: {
              categories: this.chartData.map(function( value ) {
                if (this.length > 0) {
                  let result = this.filter(function(languageType) {
                      return languageType.technology_id == this.technology_id;
                  }, value);
                  return result[0].name;
                }
                return value.name;
              }, this.languageTypes),
              labels: {
                style: {
                  colors: ["#C388FF", "#889FFF", "#C9EFA8", "#DFDC8A", "#DDB0A8", "#D3D3D3"],
                  fontSize: '12px'
                }
              }
            }
        },
        series: [{
          // チャートの動的な部分
          data: this.chartData.map(function( value ) {
            return value.score;
          }),
        }],
      }
    }
  },
}
</script>
